import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgArrowUpLeft = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M18.06 18.06a1.5 1.5 0 0 1-2.121 0l-7.44-7.439V17a1.5 1.5 0 0 1-3 0V7A1.5 1.5 0 0 1 7 5.5h10a1.5 1.5 0 0 1 0 3h-6.378l7.44 7.44a1.5 1.5 0 0 1 0 2.12'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgArrowUpLeft)
export default ForwardRef
